/* eslint 'jsx-a11y/anchor-is-valid': 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Modal, Label } from 'reactstrap';
import classnames from 'classnames';
// import SelectAllCheckboxes from '../../../../Resources/SelectAllCheckboxes';
import ErrorGif from '../../../../Assets/images/Error.gif';
import { GetUserList, GetUserDetails, ClearClientData, DeleteTraneConnectUsers } from '../../../../action/Administration/administrationAction';
import {Redirect} from 'react-router-dom';
import DeleteConfirmation from '../../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import { getAllResources } from '../../../../action/cultureAction';

class ManageUsers extends Component {

    componentWillMount() {
        this.props.GetUserList();
    }
    componentDidMount(){
        if(this.props.getLabels["ActionsAndSettings.UAText.Text"] === undefined){
            this.props.getAllResources();
        }
    }
    constructor(props) {
        super(props)
        this.state = {
            IsRequiresAdministratorError: false,
            redirectNewUser: false,
            redirectEditUser: false,
            Deletemodal: false,
            DeleteUserID: 0,
            IsRedirectToLogout: false
        }
        this.redirect = this.redirect.bind(this);
        this.DeleteUser = this.DeleteUser.bind(this);
        this.LoadUser = this.LoadUser.bind(this);
    }

    redirect(){
        this.props.ClearClientData();
        this.setState({redirectNewUser:true});
    }

    LoadUser(UserId){
        this.props.GetUserDetails(UserId);
        this.props.ClearClientData();
        this.setState({redirectEditUser:true});
    }

    DeleteUser(UserId){
        this.setState({ Deletemodal: true, DeleteUserID: UserId, IsRequiresAdministratorError:false });
    }

    /* Delete Confirmation*/
    Delete = (someArg) => {
        if (someArg === "yes") {
            var IsValid = true;
            if(this.props.UsersList !== undefined && this.props.UsersList !== "" && this.props.UsersList.length){
                var AdminUserCount = this.props.UsersList.filter(x => x.roleName === "Administrator" && x.userID !== Number(this.state.DeleteUserID));
                if(AdminUserCount.length <= 0){
                    IsValid = false;
                    this.setState({ IsRequiresAdministratorError:true });
                }
            }
            else{
                IsValid = false;
                this.setState({ IsRequiresAdministratorError:true });
            }
            if(IsValid){
                var Data = [];
                Data.push({ "userId": Number(this.state.DeleteUserID) });
                this.props.DeleteTraneConnectUsers(Data);
                var LoggedOnUser = this.props.LoggedOnUser;
                if(LoggedOnUser !== undefined && LoggedOnUser.user_info !== undefined && LoggedOnUser.user_info !== null){
                    if(LoggedOnUser.user_info.id === Number(this.state.DeleteUserID))
                    {
                        this.setState({ IsRedirectToLogout : true });
                    }
                }
            }
            
        }
        this.setState({ Deletemodal: !this.state.Deletemodal });
        this.setState({ DeleteUserID: 0 });
    }

    render(UsersList,getLabels) {
        let Error_Message, UserDetails = []; 
        let label = this.props.getLabels;

        if(this.state.redirectNewUser){
            return <Redirect to={"/SystemAdmin/AddModifyUser"} />
        } 

        if(this.state.redirectEditUser){
            return <Redirect to={"/SystemAdmin/AddModifyUserSummary"} />
        }

        if(this.state.IsRedirectToLogout){
            return <Redirect to={"/PropertyMangerLogout"} />
        }

        // Error Message
        (this.state.IsRequiresAdministratorError) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />Error: You must have at least one user with full administrative privileges.  The action you are attempting would leave the system with none.</p> : Error_Message = "";

        if(this.props.UsersList !== undefined && this.props.UsersList !== "" && this.props.UsersList.length){
            UserDetails = this.props.UsersList.map(el => (
                    <tr key={el.userID}>
                        {/* <th><input type="checkbox" id={el.userID} className="UserRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("UserRows", "main_UserCheck_box"); }} /></th> */}
                        <td><p onClick={() => { this.LoadUser(el.userID) }} style={{ color: '#6890C6' }} className="link_cursor">{el.firstName + " " + el.lastName}</p></td>
                        <td>{el.loginName}</td>
                        <td><a className="nv_link link_cursor" href={"mailto:" + decodeURIComponent(encodeURIComponent(el.emailAddress))}>{el.emailAddress}</a></td>
                        <td>{el.isActive === true ? "Yes" : "No"}</td>
                        <td>{el.roleName}</td>
                        <td><a onClick={() => this.DeleteUser(el.userID)} className="nv_link link_cursor">Delete</a></td>
                    </tr>
            ));
        }

        return (
            <div className="main_container">
            <h2 className="dbd_sub_heading" style={{"width":"100%"}}>{label['ManageUserProfilesAndRoles.lnkManageProfiles.Text'] !== undefined ? label['ManageUserProfilesAndRoles.lnkManageProfiles.Text']:"Manage User Profiles"}</h2>
            <div className="clear">&nbsp;</div>
            <Label className="sub_text">Click links under User Name or E-mail Addresses for details or select rows and click an action button on the bottom.</Label>
            <br/>
            {Error_Message}

            {/* <div className="buttons_container"> */}
                {/* <a className="nv_link link_cursor" onClick={() => { this.redirect() }}>Add a New User</a> */}
                {/* <Button className="btn-black btn-md" onClick={() => { this.redirect() }} >{label['ActionsAndSettings.UserRole.NewUserLink.Text'] !== undefined ? label['ActionsAndSettings.UserRole.NewUserLink.Text'] : "Add a New User"}</Button>
                <Button className="btn-black btn-md" onClick={() => { this.DeleteUser() }} >{label['ManageTroubleshootingManuals.btnDeleteManual.Text'] !== undefined ? label['ManageTroubleshootingManuals.btnDeleteManual.Text'] : "Delete" }</Button>
            </div>   */}

            <div className="table_container">
                <Table striped responsive className="Custom_table fixed_layout">
                    <tr style={{backgroundColor:'#f9f9f9'}}>
                            {/* <th><input type="checkbox" className="main_UserCheck_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("UserRows", "main_UserCheck_box"); }} /></th> */}
                            <th className="link_cursor">{label['UserChangeLog.User ID.Text'] !== undefined ? label['UserChangeLog.User ID.Text']:"User Name"}</th>
                            <th className="link_cursor">{label['UserChangeLog.ExportUserIdHeader.Text'] !== undefined ? label['UserChangeLog.ExportUserIdHeader.Text']:"User ID"}</th>
                            <th className="link_cursor">{label['AddAlarmEmailRouting2.ColHeader.Text'] !== undefined ? label['AddAlarmEmailRouting2.ColHeader.Text'] : "E-mail Address"}</th>
                            <th className="link_cursor">{label['UserChangeLog.TimedOverrideActive.Text'] !== undefined ? label['UserChangeLog.TimedOverrideActive.Text'] :"Active"}</th>
                            <th className="link_cursor">Role</th>
                            <th></th>
                    </tr>
                </Table>
            </div>
            <div className="table_container heightAsPercent" style={{ overflowY: 'auto' }}>
                <Table striped responsive className="Custom_table fixed_layout" style={{ overflow: 'hidden' }}>
                    <tbody>
                        <tr></tr>
                        {UserDetails}
                    </tbody>
                </Table>
            </div>
            <Modal isOpen={this.state.Deletemodal} Deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                <DeleteConfirmation parentToChildData={["Delete User Profiles", "You are about to delete the selected users from the system. Do you want to continue? Click yes to delete the user or No to Cancel."]} Delete={this.Delete} />
            </Modal>
        </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        UsersList: state.InstallationsRootReducer.UserLists,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        LoggedOnUser: state.userDetailsRootReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetUserList: () => dispatch(GetUserList()),
        GetUserDetails: (data) => dispatch(GetUserDetails(data)),
        ClearClientData: () => dispatch(ClearClientData()),
        DeleteTraneConnectUsers: (data) => dispatch(DeleteTraneConnectUsers(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);

